module.exports = __webpack_public_path__ + "img/icon-pause--green.bdbfbb18.svg";